import { render } from "./assetView.vue?vue&type=template&id=6ad981c8&scoped=true"
import script from "./assetView.vue?vue&type=script&lang=js"
export * from "./assetView.vue?vue&type=script&lang=js"

import "./assetView.vue?vue&type=style&index=0&id=6ad981c8&lang=scss"
import "./assetView.vue?vue&type=style&index=1&id=6ad981c8&lang=scss&scoped=true"

import exportComponent from "/Users/ethan/Desktop/zixel/zetaverseDev/zetaverseweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad981c8"]])

export default __exports__